import React from 'react'

class Slider extends React.Component {
  render() {
    return <div>Slider</div>
  }
}

export default Slider
